import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { FarmService } from "src/app/services/farm-service.service";
import { ProcessService } from "src/app/services/process.service";

import { PlotEventComponent } from "../plot-event/plot-event.component";
import { PlotExperimentComponent } from "../plot-experiment/plot-experiment.component";
import { PlotGrowthComponent } from "../plot-growth/plot-growth.component";
import { PlotYieldComponent } from "../plot-yield/plot-yield.component";
import { YieldReportComponent } from "../yield-report/yield-report.component";

// import { Swiper } from 'ngx-swiper-wrapper';
declare var $: any;
// If you are using ES6, then
// import CanvasJS from 'canvasjs';

@Component({
  selector: "smart-farm-detail",
  templateUrl: "./farm-detail.component.html",
  styleUrls: [
    "./farm-detail.component.css",
    "../../../assets/css/platform-color.css",
  ],
})
export class FarmDetailComponent implements OnInit, OnDestroy {
  @ViewChild(PlotEventComponent) plotEventCMP: PlotEventComponent;
  @ViewChild(PlotGrowthComponent) plotGrowthCMP: PlotGrowthComponent;
  @ViewChild(PlotExperimentComponent)
  plotExperimentCMP: PlotExperimentComponent;
  @ViewChild(PlotYieldComponent) plotYieldCMP: PlotYieldComponent;
  @ViewChild(YieldReportComponent) YieldReportCMP: YieldReportComponent;
  tabClasses: any;
  farmId: any;
  plotId: any;
  cropId: any;
  zoneId: any;
  plot: any;
  template: any = sessionStorage.getItem("template");
  showpage: any;

  constructor(
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private farmService: FarmService,
    private router: Router
  ) {}

  async ngOnInit() {
    this.farmId = this.route.snapshot.queryParams["farmId"];
    this.plotId = this.route.snapshot.queryParams["plotId"];
    this.cropId = this.route.snapshot.queryParams["cropId"];
    this.zoneId = this.route.snapshot.queryParams["zoneId"];

    if (
      this.farmId === undefined ||
      this.plotId === undefined ||
      this.cropId === undefined ||
      this.zoneId === undefined
    ) {
      this.backtoDashboard();
    }

    sessionStorage.setItem("farmId", this.farmId);
    this.getPlot();
    this.spinner.show();
    if (sessionStorage.getItem("page-detail") == "null" || sessionStorage.getItem("page-detail") == null) {
      this.showpage = "ข้อมูลของแปลง";
    } else {
      this.showpage = sessionStorage.getItem("page-detail");

      setTimeout(async () => {
        this.setCurrentTab();
      }, 200);
    }
    setTimeout(async () => {
      this.spinner.hide();
    }, 3000);
  }
  ngOnDestroy() {
    $("#setEmoticon").modal("hide");
    sessionStorage.setItem("page-detail", null);
  }

  async getPlot() {

    await this.farmService
      .getPlotDetailByID(this.plotId)
      .subscribe(async (success) => {
   
        if (success.code == 200) {
          this.plot = success.data[0];
        }
      });
  }
  backtoDashboard() {
    this.router.navigate(["/dashboard"]).then(() => {
      window.location.reload();
    });
  }

  public ChangingQueryParams(params, handling) {
    const queryParams: Params = params;
    this.router.navigate(["."], {
      relativeTo: this.route,
      queryParams: queryParams,
      replaceUrl: true,
      queryParamsHandling: handling, // remove to replace all query params by provided
    });
  }

  onClick(value) {
    if (value == "event" || value == "กิจกรรม") {
      $("#tab_1").removeClass("underline-li");
      $("#tab_2").addClass("underline-li");
      $("#tab_3").removeClass("underline-li");
      $("#tab_4").removeClass("underline-li");
      $("#tab_5").removeClass("underline-li");
      $("#tab_6").removeClass("underline-li");
      this.showpage = "กิจกรรม";
      sessionStorage.setItem("page-detail", "กิจกรรม");
      this.plotEventCMP.reload();
    } else if (value == "growth" || value == "ข้อมูลการเจริญเติบโต") {
      $("#tab_1").removeClass("underline-li");
      $("#tab_3").addClass("underline-li");
      $("#tab_2").removeClass("underline-li");
      $("#tab_4").removeClass("underline-li");
      $("#tab_5").removeClass("underline-li");
      $("#tab_6").removeClass("underline-li");
      this.showpage = "ข้อมูลการเจริญเติบโต";
      sessionStorage.setItem("page-detail", "ข้อมูลการเจริญเติบโต");
      this.plotGrowthCMP.reload();
    } else if (value == "yield" || value == "ผลผลิต") {
      $("#tab_1").removeClass("underline-li");
      $("#tab_4").addClass("underline-li");
      $("#tab_2").removeClass("underline-li");
      $("#tab_3").removeClass("underline-li");
      $("#tab_5").removeClass("underline-li");
      $("#tab_6").removeClass("underline-li");
      this.showpage = "ผลผลิต";
      sessionStorage.setItem("page-detail", "ผลผลิต");
      this.plotYieldCMP.reload();
    } else if (value == "demo" || value == "การทดลอง") {
      $("#tab_1").removeClass("underline-li");
      $("#tab_5").addClass("underline-li");
      $("#tab_2").removeClass("underline-li");
      $("#tab_3").removeClass("underline-li");
      $("#tab_4").removeClass("underline-li");
      $("#tab_6").removeClass("underline-li");
      this.showpage = "การทดลอง";
      sessionStorage.setItem("page-detail", "การทดลอง");
      this.plotExperimentCMP.reload();
    } else if (value == "detail" || value == "ข้อมูลของแปลง") {
      $("#tab_2").removeClass("underline-li");
      $("#tab_1").addClass("underline-li");
      $("#tab_3").removeClass("underline-li");
      $("#tab_4").removeClass("underline-li");
      $("#tab_5").removeClass("underline-li");
      $("#tab_6").removeClass("underline-li");
      this.showpage = "ข้อมูลของแปลง";
      sessionStorage.setItem("page-detail", "ข้อมูลของแปลง");
    } else if (value == "calendar-image" || value == "รูปภาพและวิดีโอ") {
      $("#tab_1").removeClass("underline-li");
      $("#tab_2").removeClass("underline-li");
      $("#tab_3").removeClass("underline-li");
      $("#tab_4").removeClass("underline-li");
      $("#tab_5").removeClass("underline-li");
      $("#tab_6").addClass("underline-li");
      this.showpage = "รูปภาพและวิดีโอ";
      sessionStorage.setItem("page-detail", "รูปภาพและวิดีโอ");
    }
    this.ChangingQueryParams(
      {
        farmId: this.farmId,
        plotId: this.plotId,
        cropId: this.cropId,
        zoneId: this.zoneId,
      },
      null
    );
  }

  setCurrentTab() {
    if(this.showpage == 'ข้อมูลของแปลง'){
      $("#tab_2").removeClass("underline-li");
      $("#tab_1").addClass("underline-li");
      $("#tab_3").removeClass("underline-li");
      $("#tab_4").removeClass("underline-li");
      $("#tab_5").removeClass("underline-li");
      $("#tab_6").removeClass("underline-li");
    }else if(this.showpage == 'กิจกรรม'){
      $("#tab_1").removeClass("underline-li");
      $("#tab_2").addClass("underline-li");
      $("#tab_3").removeClass("underline-li");
      $("#tab_4").removeClass("underline-li");
      $("#tab_5").removeClass("underline-li");
      $("#tab_6").removeClass("underline-li");
    }else if(this.showpage == 'ผลผลิต'){
      $("#tab_1").removeClass("underline-li");
      $("#tab_4").addClass("underline-li");
      $("#tab_2").removeClass("underline-li");
      $("#tab_3").removeClass("underline-li");
      $("#tab_5").removeClass("underline-li");
      $("#tab_6").removeClass("underline-li");
    }
  }
}
